import React from 'react';
import PropTypes from 'prop-types';

import { isBlank } from 'helpers/string_helpers';

export default function LoadErrorMessage({ loadError }) {
  if (isBlank(loadError)) return null;

  return (
    <div className="alert alert-danger">
      An error occurred when loading: <code>{loadError}</code>
    </div>
  );
}

LoadErrorMessage.propTypes = {
  loadError: PropTypes.string
};
